function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "BG",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "apps",
  d: "M7.258,9.229h-4.6A.657.657,0,0,0,2,9.886v4.6a.657.657,0,0,0,.657.657h4.6a.657.657,0,0,0,.657-.657v-4.6A.657.657,0,0,0,7.258,9.229Zm-.657,4.6H3.314V10.543H6.6ZM14.487,2h-4.6a.657.657,0,0,0-.657.657v4.6a.657.657,0,0,0,.657.657h4.6a.657.657,0,0,0,.657-.657v-4.6A.657.657,0,0,0,14.487,2Zm-.657,4.6H10.543V3.314h3.286Zm.657,2.629h-4.6a.657.657,0,0,0-.657.657v4.6a.657.657,0,0,0,.657.657h4.6a.657.657,0,0,0,.657-.657v-4.6A.657.657,0,0,0,14.487,9.229Zm-.657,4.6H10.543V10.543h3.286ZM7.258,2h-4.6A.657.657,0,0,0,2,2.657v4.6a.657.657,0,0,0,.657.657h4.6a.657.657,0,0,0,.657-.657v-4.6A.657.657,0,0,0,7.258,2ZM6.6,6.6H3.314V3.314H6.6Z",
  transform: "translate(3.428 3.428)",
  fill: "#7e84a3"
});

function SvgGrayMyApps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "grayMyApps",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayMyApps);
export default __webpack_public_path__ + "static/media/grayMyApps.a742b6c2.svg";
export { ForwardRef as ReactComponent };